import { observer } from "mobx-react-lite";
import { TextField, Input, Select, ListBox, ListBoxItem } from "@heroui/react";
import { contractorDetailStore } from "@/stores/ContractorDetailStore";
import type { LegalFormData } from "@/stores/ContractorDetailStore/legal-store/LegalDataSubStore";
import { FormField } from "../form/FormField";
import {
  applyPhoneMask,
  phoneMaskToRaw,
} from "@/pages/ContractorDetailPage/constants";

const Step3Director: React.FC = observer(() => {
  const { legal } = contractorDetailStore;
  const { form, validationErrors: errors } = legal.form;

  const setField = (field: keyof LegalFormData, value: string) =>
    legal.form.setField(field, value);

  return (
    <div className="scd-drawer-form">
      <div className="scd-drawer-row">
        <FormField
          label="Фамилия"
          error={errors.directorLastName}
          required
          tooltip="Фамилия руководителя организации"
        >
          <TextField fullWidth>
            <Input
              placeholder="Иванов"
              value={form.directorLastName}
              onChange={(e) => setField("directorLastName", e.target.value)}
            />
          </TextField>
        </FormField>
        <FormField
          label="Имя"
          error={errors.directorFirstName}
          required
          tooltip="Имя руководителя организации"
        >
          <TextField fullWidth>
            <Input
              placeholder="Иван"
              value={form.directorFirstName}
              onChange={(e) => setField("directorFirstName", e.target.value)}
            />
          </TextField>
        </FormField>
      </div>
      <div className="scd-drawer-row">
        <FormField
          label="Отчество"
          error={errors.directorMiddleName}
          tooltip="Отчество руководителя (при наличии)"
        >
          <TextField fullWidth>
            <Input
              placeholder="Иванович"
              value={form.directorMiddleName}
              onChange={(e) => setField("directorMiddleName", e.target.value)}
            />
          </TextField>
        </FormField>
        <FormField
          label="Телефон"
          error={errors.directorPhone}
          tooltip="Контактный телефон руководителя. Формат: +7XXXXXXXXXX"
        >
          <TextField fullWidth>
            <Input
              placeholder="+79001234567"
              value={applyPhoneMask(form.directorPhone)}
              onChange={(e) => {
                const raw = phoneMaskToRaw(e.target.value);
                setField("directorPhone", raw);
              }}
              maxLength={12}
            />
          </TextField>
        </FormField>
      </div>
      <FormField
        label="Гражданство"
        error={errors.directorCitizenship}
        tooltip="Гражданство руководителя. Код страны по ISO 3166-1"
      >
        <Select
          fullWidth
          selectedKey={form.directorCitizenship}
          onSelectionChange={(key) =>
            setField("directorCitizenship", (key as string) ?? "RUS")
          }
        >
          <Select.Trigger>
            <Select.Value />
            <Select.Indicator />
          </Select.Trigger>
          <Select.Popover>
            <ListBox>
              <ListBoxItem id="RUS">Россия</ListBoxItem>
              <ListBoxItem id="BLR">Беларусь</ListBoxItem>
              <ListBoxItem id="KAZ">Казахстан</ListBoxItem>
              <ListBoxItem id="UZB">Узбекистан</ListBoxItem>
              <ListBoxItem id="KGZ">Кыргызстан</ListBoxItem>
              <ListBoxItem id="ARM">Армения</ListBoxItem>
              <ListBoxItem id="TJK">Таджикистан</ListBoxItem>
            </ListBox>
          </Select.Popover>
        </Select>
      </FormField>
    </div>
  );
});

Step3Director.displayName = "Step3Director";
export default Step3Director;
